module.exports = __webpack_public_path__ + "img/404.54bd1801.png";